/* istanbul ignore file */
export const DSN = 'https://38b3d94ac28441fe9fe772abd19a21b9@sentry.io/2237480';
